<template>
  <div>
    <div v-if="$mq.lg" @click="toggleSignInModal" class="cursor-pointer">
      <div v-if="$mq.md" class="text-center">
        <button
          :class="{
            'bg-white text-black': isAuctionsPage,
            'btn-primary-black': !isAuctionsPage,
          }"
          class="btn whitespace-nowrap focus:outline-none"
        >
        {{ isAuctionsPage ? "Sign in to bid" : "Sign In" }}
        <i class="far fa-arrow-right-to-bracket text-12 ml-6 md:text-base"></i>
        </button>
      </div>
      <div v-else class="font-bold text-black text-16 leading-1.2 py-24 uppercase">
        Sign In
        <i class="far fa-arrow-right-to-bracket text-12 ml-6 md:text-base"></i>
      </div>
    </div>

    <div v-else @click="toggleSignInModal">
      <button class="btn btn-primary-black focus:outline-none">
        Sign In <i class="far fa-arrow-right-to-bracket text-12 ml-6 md:text-base"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SignInButton",

  props: {
    isAuctionsPage: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    async toggleSignInModal() {
      if (!this.$mq.lg) {
        await window.TheNavbarMobilePanel.close();
      }

      this.$root.$refs.signInModal.toggle();
    },
  },
};
</script>
